import React from 'react';

const RowRender = (properties) => {
    const { row, props, onDrop, onDragStart, customStyle, exitEdit, onEditCellValue, onRowClick, draggableProp } = { ...properties };
    
    const additionalProps = {
        onDragStart: (e) => onDragStart(e, props.dataItem),
        onDragOver: (e) => {
            e.preventDefault();
        },
        onDrop: (e) => { onDrop(e);},
        draggable: draggableProp,
        onBlur: (e) => {
            if (e.nativeEvent.target.localName === "input") {
                if (e.nativeEvent.type == 'focusout') {
                    onEditCellValue();
                }
                setTimeout(() => {
                    const activeElement = document.activeElement;
                    if (
                        activeElement &&
                        activeElement.className.indexOf("k-calendar") < 0
                    ) {
                        exitEdit();
                    }
                });
            }
        },
        onKeyDown: (e) => {
            if (e.nativeEvent.key == 'Enter') {
                onEditCellValue();
            }
        },
        onClick: (e) => {
            onRowClick(props, false);
        }
    };

    return React.cloneElement(
        row,
        { ...row.props, ...additionalProps, ...customStyle },
        row.props.children
    );
}


export default RowRender;
